<mat-card>{{'systemData' | translate}}</mat-card>

<div align="end" class="row" style="padding:10px 10px 0 0;">


  <button mat-raised-button color="primary" (click)="submit()">
    <mat-icon>done</mat-icon>
    {{'submit' | translate}}
  </button>
  &nbsp;
  &nbsp;
</div>


<mat-grid-list cols="18" rowHeight="50px">
  <mat-grid-tile colspan="3">
    <mat-label>حسن سيرة </mat-label>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <mat-slide-toggle (change)="EnableServices($event,1)" [color]="color" [checked]="EnableHosonSira">
    </mat-slide-toggle>
  </mat-grid-tile>

  <mat-grid-tile colspan="3">
    <mat-label> عدم محكومية</mat-label>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <mat-slide-toggle (change)="EnableServices($event,2)" [color]="color" [checked]="EnableMahkomiah">
    </mat-slide-toggle>
  </mat-grid-tile>

  <mat-grid-tile colspan="3">
    <mat-label> مكرمة</mat-label>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <mat-slide-toggle (change)="EnableServices($event,3)" [color]="color" [checked]="EnableMakramah">
    </mat-slide-toggle>
  </mat-grid-tile>

  <mat-grid-tile colspan="3">
    <mat-label> مكرمة جيش</mat-label>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <mat-slide-toggle (change)="EnableServices($event,4)" [color]="color" [checked]="EnableMakramahJeash">
    </mat-slide-toggle>
  </mat-grid-tile>

  <mat-grid-tile colspan="3">
    <mat-label> القبول الموحد</mat-label>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <mat-slide-toggle (change)="EnableServices($event,5)" [color]="color" [checked]="EnableUniformAcceptance">
    </mat-slide-toggle>
  </mat-grid-tile>

  <mat-grid-tile colspan="3">
    <mat-label> رسوم الجامعة</mat-label>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <mat-slide-toggle (change)="EnableServices($event,6)" [color]="color" [checked]="EnableUnivercityFees">
    </mat-slide-toggle>
  </mat-grid-tile>

</mat-grid-list>

<mat-grid-list cols="5" rowHeight="100px">
  <mat-grid-tile></mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field appearance="standard">
      <mat-label>{{'hosonSiraPrice' | translate}}</mat-label>
      <input matInput [(ngModel)]="systemData.hosonSiraPrice">
    </mat-form-field>

  </mat-grid-tile>

  <mat-grid-tile>
    <mat-form-field appearance="standard">
      <mat-label>{{'mahkomiahPrice' | translate}}</mat-label>
      <input matInput [(ngModel)]="systemData.mahkomiahPrice">
    </mat-form-field>
  </mat-grid-tile>

  <mat-grid-tile>
    <mat-form-field appearance="standard">
      <mat-label>{{'makramaPrice' | translate}}</mat-label>
      <input matInput [(ngModel)]="systemData.makramaPrice">
    </mat-form-field>
  </mat-grid-tile>

</mat-grid-list>

<mat-grid-list cols="5" rowHeight="100px">
  <mat-grid-tile></mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field appearance="standard">
      <mat-label>{{'makramaJeashPrice' | translate}}</mat-label>
      <input matInput [(ngModel)]="systemData.makramaJeashPrice">
    </mat-form-field>

  </mat-grid-tile>

  <mat-grid-tile>
    <mat-form-field appearance="standard">
      <mat-label>{{'uniformAccpPrice' | translate}}</mat-label>
      <input matInput [(ngModel)]="systemData.uniformAcceptancePrice">
    </mat-form-field>
  </mat-grid-tile>

  <mat-grid-tile>
    <mat-form-field appearance="standard">
      <mat-label>{{'univFeesPrice' | translate}}</mat-label>
      <input matInput [(ngModel)]="systemData.univercityFeesPrice">
    </mat-form-field>
  </mat-grid-tile>

</mat-grid-list>

<!-- <mat-grid-list cols="5" rowHeight="100px"> -->
<!-- <mat-grid-tile></mat-grid-tile> -->
<!-- <mat-grid-tile colspan="3"> -->

<div flex fxLayout="row">
  <div fxFlex="5"></div>
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsAr11' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.hosonSiraTermsAndConditionAr"></textarea>
    </mat-form-field>
  </div>
  &nbsp;
  &nbsp;
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsEn11' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.hosonSiraTermsAndConditionEn"></textarea>
    </mat-form-field>
  </div>
  <div fxFlex="5"></div>
</div>


<div flex fxLayout="row">
  <div fxFlex="5"></div>
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsAr12' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.mahkomiahTermsAndConditionAr"></textarea>
    </mat-form-field>
  </div>
  &nbsp;
  &nbsp;
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsEn12' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.mahkomiahTermsAndConditionEn"></textarea>
    </mat-form-field>
  </div>
  <div fxFlex="5"></div>
</div>

<div flex fxLayout="row">
  <div fxFlex="5"></div>
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsAr13' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.makramahTermsAndConditionAr"></textarea>
    </mat-form-field>
  </div>
  &nbsp;
  &nbsp;
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsEn13' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.makramahTermsAndConditionEn"></textarea>
    </mat-form-field>
  </div>
  <div fxFlex="5"></div>
</div>








<div flex fxLayout="row">
  <div fxFlex="5"></div>
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsAr14' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.makramahJeashTermsAndConditionAr"></textarea>
    </mat-form-field>
  </div>
  &nbsp;
  &nbsp;
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsEn14' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.makramahJeashTermsAndConditionEn"></textarea>
    </mat-form-field>
  </div>
  <div fxFlex="5"></div>
</div>

<div flex fxLayout="row">
  <div fxFlex="5"></div>
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsAr15' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.uniformAcceptanceTermsAndConditionAr"></textarea>
    </mat-form-field>
  </div>
  &nbsp;
  &nbsp;
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsEn15' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.uniformAcceptanceTermsAndConditionEn"></textarea>
    </mat-form-field>
  </div>
  <div fxFlex="5"></div>
</div>

<div flex fxLayout="row">
  <div fxFlex="5"></div>
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsAr16' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.univercityFeesTermsAndConditionAr"></textarea>
    </mat-form-field>
  </div>
  &nbsp;
  &nbsp;
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsEn16' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.univercityFeesTermsAndConditionEn"></textarea>
    </mat-form-field>
  </div>
  <div fxFlex="5"></div>
</div>







<div flex fxLayout="row">
  <div fxFlex="5"></div>
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsAr21' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.electricTermsAndConditionAr"></textarea>
    </mat-form-field>
  </div>
  &nbsp;
  &nbsp;
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsEn21' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.electricTermsAndConditionEn"></textarea>
    </mat-form-field>
  </div>
  <div fxFlex="5"></div>
</div>

<div flex fxLayout="row">
  <div fxFlex="5"></div>
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsAr22' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.waterTermsAndConditionAr"></textarea>
    </mat-form-field>
  </div>
  &nbsp;
  &nbsp;
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsEn22' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.waterTermsAndConditionEn"></textarea>
    </mat-form-field>
  </div>
  <div fxFlex="5"></div>
</div>


<div flex fxLayout="row">
  <div fxFlex="5"></div>
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsAr23' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.telecomTermsAndConditionAr"></textarea>
    </mat-form-field>
  </div>
  &nbsp;
  &nbsp;
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsEn23' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.telecomTermsAndConditionEn"></textarea>
    </mat-form-field>
  </div>
  <div fxFlex="5"></div>
</div>

<div flex fxLayout="row">
  <div fxFlex="5"></div>
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsAr24' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.kamamahTermsAndConditionAr"></textarea>
    </mat-form-field>
  </div>
  &nbsp;
  &nbsp;
  <div fxFlex="45">
    <mat-form-field appearance="standard">
      <mat-label>{{'termsAndConditionsEn24' | translate}}</mat-label>
      <textarea matInput [(ngModel)]="systemData.kamamahTermsAndConditionEn"></textarea>
    </mat-form-field>
  </div>
  <div fxFlex="5"></div>
</div>


<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>